module.exports = {"TXTCLI_Back":{"id":"TXTCLI_Back","defaultMessage":"Επιστροφή","flags":["TRACK"],"track":"Back"}}